module.exports = __webpack_public_path__ + "static/media/Group 55.3e4470b5.svg";